// MZ theme system (v286). Light = sitewide default: white bg, perfume color
// carries ALL text + donut, CTA = perfume bg / white text. Dark = the v4 look.
// Homepage maps the toggle to files: v1 = index.html (light), v2 = index-v2.html (dark).
// PDP bottle imagery swaps pp-<slug>.jpg <-> pp-<slug>-light.jpg (20ml stays dark
// until light 20ml renders exist). Pref persists in localStorage.
//
// THEME COPY - differs from site/js/theme.js on purpose (parity pass, 21 Sep), everything else is identical:
//  1. The store has ONE home URL. The static routing to index-v2.html was a 404 for anyone who chose dark.
//     On the store the toggle saves the choice and reloads "/" - sections/mz-home-dial.liquid and
//     assets/mz-hero2.js read the saved mode at load, exactly as the two static files did. It never navigates.
//  2. layout/theme.liquid decides the mode before first paint (html.mzlight + the dark body classes it
//     takes off), so nothing flashes. It hands over the classes it removed in window.mzDarkOff, so the
//     toggle can put them back.
//  3. The bottle swap also rewrites srcset (Shopify's image_tag emits one; a bare src change is ignored
//     while it is there) and falls back to the dark render if a -light file is missing from Files.
(function () {
  var THEME = !!(window.Shopify && window.Shopify.shop);
  var KEY = 'mz-theme';
  var pref;
  try { pref = localStorage.getItem(KEY) || 'light'; } catch (e) { pref = 'light'; }
  var path = location.pathname;
  var isV2 = /index-v2\.html$/.test(path);
  var isHome = THEME ? !!(document.body && document.body.classList.contains('template-index'))
    : isV2 || /(^|\/)index\.html$/.test(path) || /\/$/.test(path);

  // homepage routing: file IS the theme there (static draft only)
  if (isHome && !THEME) {
    if (pref === 'dark' && !isV2) { location.replace('index-v2.html'); }
    if (pref === 'light' && isV2) { location.replace('index.html'); }
  }

  var DARKCLASSES = ['pdp-dark', 'cfoot-dark', 'page-dark'];
  var removed = window.mzDarkOff || [];   // classes the layout already took off before first paint

  function apply(p) {
    document.documentElement.classList.toggle('mzlight', p === 'light');
    if (!document.body) return;
    if (p === 'light') {
      DARKCLASSES.forEach(function (c) {
        if (document.body.classList.contains(c)) { removed.push(c); document.body.classList.remove(c); }
      });
    } else {
      removed.forEach(function (c) { document.body.classList.add(c); });
      removed = [];
    }
    // bottle imagery swap — every pp render on the page (fold, showcases, cards)
    document.querySelectorAll('img[src*="pp-"], img[src*="-notes-"]').forEach(function (img) {
      var src = img.getAttribute('src') || '';
      if (p === 'light' && !/-light\.(jpg|png)/.test(src)) {
        if (/pp-[a-z-]+(-20)?\.(jpg|png)/.test(src)) swap(img, function (u) { return u.replace(/\.(jpg|png)/, '-light.$1'); });
        else if (/-notes-[a-z]+\.png/.test(src)) swap(img, function (u) { return u.replace('.png', '-light.png'); });
      } else if (p === 'dark' && /-light\.(jpg|png)/.test(src)) {
        swap(img, function (u) { return u.replace('-light.jpg', '.jpg').replace('-light.png', '.png'); });
      }
    });
  }

  // src AND every srcset candidate through the same rewrite; a 404 puts the old pair back
  function swap(img, fn) {
    var src = img.getAttribute('src'), set = img.getAttribute('srcset');
    img.addEventListener('error', function () {
      img.src = src;
      if (set) img.setAttribute('srcset', set);
    }, { once: true });
    if (set) img.setAttribute('srcset', set.split(',').map(fn).join(','));
    img.src = fn(src);
  }

  window.mzThemeToggle = function () {
    pref = pref === 'light' ? 'dark' : 'light';
    try { localStorage.setItem(KEY, pref); } catch (e) {}
    if (isHome && THEME) { location.reload(); return; }
    if (isHome) { location.href = pref === 'dark' ? 'index-v2.html' : 'index.html'; return; }
    apply(pref);
  };

  // ── v312: versions PINNED (Faiz, 2026-08-20) ────────────────────────────────
  // Light = v2 (white bg, vibrant titles). Dark = v3 (black gradient, vibrant titles).
  // ponytail: no toggle, no localStorage — the choice is locked, so state has nothing to hold.
  function applyVer() {
    if (!document.body) return;
    document.body.setAttribute('data-ver', document.body.classList.contains('v2dark') ? '3' : '2');
  }

  function boot() {
    apply(pref);
    if (document.getElementById('hero2')) applyVer();
    var play = document.getElementById('navPlay');
    if (!play || document.getElementById('themeBtn')) return;
    var b = document.createElement('a');
    b.href = '#'; b.id = 'themeBtn'; b.className = play.className || 'h2-ico';
    b.setAttribute('aria-label', 'Toggle light / dark mode');
    b.innerHTML =
      '<svg class="ico-moon" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><path d="M21 12.8A9 9 0 1 1 11.2 3a7 7 0 0 0 9.8 9.8z"/></svg>' +
      '<svg class="ico-sun" viewBox="0 0 24 24" fill="none" stroke="currentColor" stroke-width="1.8" stroke-linecap="round" stroke-linejoin="round"><circle cx="12" cy="12" r="4"/><path d="M12 2v2M12 20v2M4.9 4.9l1.4 1.4M17.7 17.7l1.4 1.4M2 12h2M20 12h2M4.9 19.1l1.4-1.4M17.7 6.3l1.4-1.4"/></svg>';
    play.parentNode.insertBefore(b, play);
    b.addEventListener('click', function (e) { e.preventDefault(); window.mzThemeToggle(); });
  }
  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', boot);
  else boot();
})();
